"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var SearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter"));
var filter_1 = require("utils/filter");
var SaaSAnalysedSearchAndFilter = function (_a) {
    var serviceStats = _a.serviceStats, filterProps = _a.filterProps, searchProps = _a.searchProps;
    var serviceOptions = serviceStats === null || serviceStats === void 0 ? void 0 : serviceStats.map(filter_1.makeServiceOption);
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end", mb: 1, maxWidth: 1060 }, { children: (0, jsx_runtime_1.jsx)(SearchAndFilter_1.default, { searchProperties: searchProps, 
            // ToDo 1: refactor FilterProps to use results and setResults
            // ToDo 2: add options to FilterProps (it can be passed by useFilterServices)
            filterProperties: {
                options: serviceOptions,
                results: filterProps.selectedFilters,
                setResults: filterProps.setSelectedFilters,
                disableGroupOptions: true,
            } }) })));
};
exports.default = SaaSAnalysedSearchAndFilter;
